import styled from "styled-components";

export const MemberDetailModalWrapper = styled.div`
  width: 521px;
  border-radius: 13px;
  background: #fff;
  box-shadow: 0 4px 4px 0 rgba(0, 0, 0, 0.25);
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 1000;
  padding: 40px;
  display: flex;
  flex-direction: column;
  gap: 30px;
`;

export const MemberDetailModalHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: #1a191a;
  font-family: Pretendard;
  font-size: 23px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
`;

export const MemberDetailInfoWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;

  .item {
    flex: 1;
    color: #121212;
    text-align: center;
    font-family: Pretendard;
    font-size: 11.466px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
  }
`;

export const MemberDetailInfoHeader = styled.div`
  display: flex;
  padding: 0 15px;
`;

export const MemberDetailInfoItem = styled.div`
  display: flex;
  padding: 0 15px;
  height: 40px;
  align-items: center;
  border-radius: 11.466px;
  background: #ecf0f3;
`;

export const MemberDetailMemoWrapper = styled.div`
  color: #1a191a;
  font-family: Pretendard;
  font-size: 20px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;

  > textarea {
    margin-top: 10px;
    box-sizing: border-box;
    height: 200px;
    width: 100%;
    padding: 15px;
    border-radius: 11px;
    border: 1px solid #ecf0f3;
    outline: none;
    color: #121212;
    font-family: Pretendard;
    font-size: 15px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
    resize: none;
  }
`;

export const MemberDetailButtonWrapper = styled.div`
  display: flex;
  gap: 10xp;
  width: 100%;

  > div {
    display: flex;
    flex: 1;
    height: 48px;
    justify-content: center;
    align-items: center;
    flex-shrink: 0;
    color: #6436e7;
    text-align: center;
    font-family: Pretendard;
    font-size: 15px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
    letter-spacing: -0.165px;
    border-radius: 11.466px;
    cursor: pointer;

    &.save {
      background: #6436e7;
      color: #fff;
    }
  }
`;
